import { color, oklchToHex } from "./color"

export function getDefaultAvatar(userId: string) {
  const colors = [
    color.sand100,
    color.amber200,
    color.indigo300,
    color.orange400,
    color.rose500,
    color.emerald600,
  ]
    .map(oklchToHex)
    .map(color => color.replace("#", ""))
    .join(",")
  return `https://api.dicebear.com/9.x/shapes/svg?seed=${userId}&backgroundColor=${colors}&shape1Color=${colors}&shape2Color=${colors}&shape3Color=${colors}`
}
